export const seniorFinanceResume = `
【職務概要】
財務会計の専門家として約15年のキャリアを歩み、IFRS・JGAAP双方に精通したプロフェッショナルです。連結決算、企業買収（M&A）に伴うデューデリジェンス、財務戦略の立案から事業部門の業績管理まで、幅広い業務に携わってきました。特に製造業における原価管理システムの最適化と、財務報告の透明性向上において実績を残しています。

直近ではFintech技術の活用による財務プロセスの効率化に取り組み、RPAやAIの導入を主導して月次決算の処理時間を40%削減するなどの成果を上げました。国際会計基準（IFRS）導入プロジェクトでは、リーダーとして全社横断チームを率い、予定より3ヶ月早い移行を実現しました。

財務部門が単なる数字の管理者ではなく、事業の意思決定を支援する戦略的パートナーとして機能すべきと考え、経営層への積極的な提言や、事業部門との協働を重視しています。税制改正や会計基準の変更にも常にアンテナを張り、企業価値向上に貢献できる財務のあり方を追求しています。

【職務経歴】
・株式会社Algomatic製造 （2019年4月〜現在）
  ○ 会社概要：自動車・産業機器部品を製造する東証プライム上場企業。従業員数約3,000名、年商1,200億円。
  ○ 職務内容：財務経理本部 財務部長
     - 連結決算業務の統括（国内子会社7社、海外子会社5社）
     - 取締役会・経営会議向け財務報告資料の作成と報告
     - 中期経営計画における財務戦略の立案・実行
     - 事業部の業績管理と分析（予実管理、KPI設定、改善提案）
     - 監査法人、税理士法人、金融機関との折衝
     - 財務部門（15名）のマネジメント
  ○ 具体的な成果：
     - IFRSへの移行プロジェクトをリードし、当初計画より3ヶ月前倒しで完了
     - RPA導入による決算業務の自動化を推進し、月次決算業務を5日から3日に短縮
     - キャッシュ・コンバージョン・サイクル改善により、営業キャッシュフローを前年比15%増加
     - 事業部との連携強化により、不採算製品の特定と改善を実施、営業利益率を1.5ポイント向上
  ○ 使用した技術・ツール：
     - SAP ERP、Hyperion、Tableau、Power BI、UiPath（RPA）
  ○ 身につけたスキル：
     - 国際会計基準（IFRS）の実務適用能力
     - 大規模プロジェクトのマネジメントスキル
     - データ分析に基づく経営支援能力

・株式会社Algomaticグループ （2014年4月〜2019年3月）
  ○ 会社概要：総合商社。従業員数約1,500名、年商3,000億円。
  ○ 職務内容：財務経理部 課長
     - 単体・連結決算業務
     - M&Aに伴う財務デューデリジェンス
     - 海外子会社の会計管理・指導
     - 資金調達・運用の立案・実行
     - IR資料作成支援
  ○ 具体的な成果：
     - 海外子会社の会計基準統一プロジェクトを主導し、グループ全体の会計プロセスを標準化
     - 資金管理システムの刷新により、グループ全体の資金効率を8%改善
     - 3件のM&A案件で財務DD担当として参画、うち1件では5億円の価格調整を実現
  ○ 使用した技術・ツール：
     - Oracle EBS、Excel（高度な関数・マクロ）、Bloomberg
  ○ 身につけたスキル：
     - M&A関連の財務分析・評価能力
     - グローバル会計管理のノウハウ
     - プロジェクトファイナンスの知識

・株式会社Algomatic会計事務所 （2009年4月〜2014年3月）
  ○ 会社概要：大手監査法人系の会計事務所。従業員数約500名。
  ○ 職務内容：マネージャー
     - 上場企業の法定監査（製造業・小売業を中心に担当）
     - 内部統制構築支援
     - IFRS導入コンサルティング
     - 会計・税務アドバイザリー
  ○ 具体的な成果：
     - 担当クライアント10社の監査をリード
     - クライアント企業の不適切会計処理を発見し、早期の是正を実現
     - IFRS導入支援プロジェクトで主要メンバーとして活躍し、大手製造業の移行を成功
  ○ 使用した技術・ツール：
     - 監査ツール（ACL）、会計ソフトウェア各種
  ○ 身につけたスキル：
     - 高度な会計監査スキル
     - 内部統制評価の専門知識
     - コンサルティングスキル

【受賞・表彰歴】
・2022年 社内MVP表彰：IFRS移行プロジェクトの成功的リーダーシップに対して
・2021年 CFO特別賞：財務業務改革による業務効率化の推進
・2017年 Algomaticグループ改善提案優秀賞：グループ資金管理システム刷新による資金効率改善
・2012年 会計事務所内優秀社員賞：大規模監査プロジェクトの成功的な完遂

【資格】
・公認会計士（2011年4月）
・米国公認会計士（USCPA）（2013年5月）
・CFE（公認不正検査士）（2015年11月）
・日商簿記1級（2008年7月）
・TOEIC 870点（2020年9月）

【マネジメント経験】
・現職では財務部門15名のマネジメントを担当
・部下の育成に注力し、過去3年間で課長2名、主任3名を登用
・メンバー全員に年間40時間以上の専門研修受講を義務付け、スキルアップを推進
・週次でナレッジシェアミーティングを実施し、部門内の情報共有と専門性向上を図る
・若手社員向けに「財務視点で見るビジネス」研修を企画・実施し、全社から高評価

【語学力】
・英語：ビジネスレベル（TOEIC 870点）
  ○ 海外子会社とのやり取り、財務報告書の英文作成、海外投資家向け説明会対応
  ○ 英語での会議進行、プレゼンテーション経験あり
・中国語：基礎レベル
  ○ 簡単な会話と読み書きが可能
` as const;
